module.exports = require('./helpers/bundle-url').getBundleURL('huCuf') + "logo-dark.eefe0b7f.svg";